import { IconExpand } from '../ui/icons';
import { t } from '../../localization/t';

/**
 * Per-square expand button. One small button at the top-left corner of
 * every grid cell holding more than three cards. Clicking it fans the
 * cell open (same openCellFocus path as the held expand hotkey). Position
 * is mutated each frame by GameBoard.updateCellStackBadgeOverlays via the
 * registerRefs hook; React only re-renders when the `badges` array itself
 * churns (a cell crossing the 4-card threshold). The build step suppresses
 * buttons while a prompt owns board clicks, so the button can never swallow
 * a target-prompt click.
 */
export default function CellStackBadges({ badges, registerRefs, onOpen }) {
  if (!badges || badges.length === 0) return null;
  return (
    <div>
      {badges.map((b) => (
        <ExpandButton key={b.cellKey} badge={b} registerRefs={registerRefs} onOpen={onOpen} />
      ))}
    </div>
  );
}

function ExpandButton({ badge, registerRefs, onOpen }) {
  const setRef = (el) => registerRefs(badge.cellKey, el);
  return (
    <button
      ref={setRef}
      type="button"
      className="cell-expand-btn"
      aria-label={t('Fan out this square')}
      onMouseDown={(e) => { e.stopPropagation(); e.preventDefault(); }}
      onClick={(e) => { e.stopPropagation(); onOpen?.(badge.cellKey); }}
    >
      <IconExpand size={12} />
    </button>
  );
}
